import { render, staticRenderFns } from "./StackedBarChart.vue?vue&type=template&id=7f8486aa&scoped=true"
import script from "./StackedBarChart.vue?vue&type=script&lang=js"
export * from "./StackedBarChart.vue?vue&type=script&lang=js"
import style0 from "./StackedBarChart.vue?vue&type=style&index=0&id=7f8486aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8486aa",
  null
  
)

export default component.exports